import type { IconProps } from './types';
import './icons.css';

export default function Trash({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-trash ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M8.125 4.792v-.625a1.875 1.875 0 0 1 3.75 0v.625M3.125 4.792h13.75M4.792 4.792v11.25c0 .92.746 1.666 1.666 1.666h7.084c.92 0 1.666-.746 1.666-1.666V4.792M8.542 8.125v6.25M11.458 8.125v6.25"
      />
    </svg>
  );
}
